import InternalChatView from './components/InternalChatView.vue';
import { frontendURL } from '../../../helper/URLHelper';

const roles = [
  'administrator',
  'agent',
  'supervisor',
  'team_supervisor',
  'seller',
  'analyzer',
  'assistant',
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/internal-chat'),
    name: 'internal_chat_dashboard',
    roles,
    component: InternalChatView,
  },
  {
    path: frontendURL('accounts/:accountId/internal-chat/:conversationId'),
    name: 'internal_chat_conversation',
    roles,
    component: InternalChatView,
    props: route => ({ conversationId: route.params.conversationId }),
  },
];
